// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  ReleaseChannel,
} from "./types";

export default {
  project: __t.string(),
  appId: __t.string(),
  get channel() {
    return ReleaseChannel;
  },
  pinnedVersionId: __t.option(__t.u64()),
  autoUpdate: __t.option(__t.bool()),
};
